import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

//From admin module
import {
  systemOwnerDeleteUserReducer,
  systemOwnerGetUserDetailReducer,
  systemOwnerLoginReducer,
  systemOwnerUpdateUserDetailReducer,
  systemOwnerRegisterAdminReducer,
  userLoginReducer,
  labManagerGetLabUsersReducer,
  labManagerRegisterUserReducer,
} from './admin_module/reducers/userReducers'
import {
  systemOwnerCreateLabReducer,
  systemOwnerLabListReducer,
  systemOwnerLabUserListReducer,
  userLabNameListReducer,
  userGetLabInfoReducer,
} from './admin_module/reducers/labReducers'

//From media module
import {
  mediaFilesCreateReducer,
  mediaFilesDeleteReducer,
  mediaFilesGetReducer,
  mediaFilesReducer,
  mediaFileUpdateReducer,
  targetMediaFileReducer,
} from './media_module/reducers/mediaReducers'

//From study module
import {
  studyListReducer,
  studyCreateReducer,
  studyDeleteReducer,
  studyActivateReducer,
  studyDectivateReducer,
  studyEditBasicReducer,
  studyDetailsReducer,
  studyEditConsentReducer,
  stageAddReducer,
  stageDeleteReducer,
  stageEditBasicReducer,
  participantGroupAddReducer,
  participantGroupDeleteReducer,
  participantGroupEditReducer,
  studyEditExceptConsentReducer,
  studyLockReducer,
  studyUnlockReducer,
  settingsSetMutationReducer,
} from './study_module/reducers/studyReducers'

//From qx module
import {
  mcCreateReducer,
  mcDeleteReducer,
  mcDetailsReducer,
  mcEditReducer,
  mcListReducer,
  qxCreateReducer,
  qxDeleteReducer,
  qxDetailsReducer,
  qxEditReducer,
  qxListReducer,
  qxLockReducer,
  qxUnlockReducer,
  qxVariableCreateReducer,
  qxVariableDeleteReducer,
  qxVariableDetailsReducer,
  qxVariableEditReducer,
  qxVariableListReducer,
} from './qx_module/reducers/qxReducers'

//From participant module
import {
  assignPartiReducer,
  partiListReducer,
  downloadTextRespReducer,
  downloadRespTimeReducer,
  createPartiReducer,
  updateFitbitTokenReducer,
  getFitbitSleepLogReducer,
  createJitaiTasksReducer,
  refreshJitaiTasksReducer,
  saveJitaiDataRespReducer,
  getJitaiDataRespReducer,
  connectAmiDeviceReducer,
} from './participant_module/reducers/participantReducers'

//From ema module
import { emaTaskListReducer } from './ema_module/reducers/emaReducers'

//From access module
import { allAccessReducer } from './access_module/reducers/accessReducers'

//From tx materials module
import {
  txPageCreateReducer,
  txPageDeleteReducer,
  txPageListReducer,
  txPageEditReducer,
  txPageDetailsReducer,
  customPageComponentCreateReducer,
  customPageComponentDeleteReducer,
  customPageComponentListReducer,
  customPageComponentEditReducer,
  customPageComponentDetailsReducer,
} from './tx_materials_module/reducers/txMaterialsReducers'

//From tx progress module
import {
  nextTxStageInfoListReducer,
  nextTxStageInfoDeleteReducer,
  nextTxStageInfoCreateReducer,
  nextTxStageInfoEditReducer,
} from './tx_progress_module/reducers/txProgressReducers'

//From diary ax module
import { diaryAxTaskListReducer } from './diary_ax_module/reducers/diaryAxReducers'

//From jitai module
import {
  jitaiMessageListReducer,
  jitaiMessageCreateReducer,
  jitaiMessageUpdateReducer,
  jitaiMessageDeleteReducer,
  jitaiVariableListReducer,
  jitaiVariableCreateReducer,
  jitaiVariableUpdateReducer,
  jitaiVariableDeleteReducer,
  jitaiDecisionRuleListReducer,
  jitaiDecisionRuleCreateReducer,
  jitaiDecisionRuleUpdateReducer,
  jitaiDecisionRuleDeleteReducer,
  jitaiRespListReducer,
  jitaiRespCreateReducer,
  jitaiRespUpdateReducer,
  jitaiRespDeleteReducer,
  jitaiScheduledTaskListReducer,
  jitaiRulesUsageReducer,
  jitaiEvaluateReducer,
  jitaiParticipantActivityReducer,
} from './jitai_module/reducers/jitaiReducers'

const reducer = combineReducers({
  // Start of admin module
  userLogin: userLoginReducer,
  labManagerGetLabUsers: labManagerGetLabUsersReducer,
  labManagerRegisterUser: labManagerRegisterUserReducer,
  labNameList: userLabNameListReducer,
  getLabInfo: userGetLabInfoReducer,

  // Start of system owner module
  systemOwnerLogin: systemOwnerLoginReducer,
  systemOwnerLabList: systemOwnerLabListReducer,
  systemOwnerLabUserList: systemOwnerLabUserListReducer,
  systemOwnerUserDelete: systemOwnerDeleteUserReducer,
  systemOwnerUserDetails: systemOwnerGetUserDetailReducer,
  systemOwnerUserUpdate: systemOwnerUpdateUserDetailReducer,
  systemOwnerLabCreate: systemOwnerCreateLabReducer,
  systemOwnerRegisterAdmin: systemOwnerRegisterAdminReducer,

  // Start of media module
  mediaFiles: mediaFilesReducer,
  createMediaFiles: mediaFilesCreateReducer,
  deleteMediaFiles: mediaFilesDeleteReducer,
  getMediaFiles: mediaFilesGetReducer,
  updateMediaFiles: mediaFileUpdateReducer,
  targetMediaFiles: targetMediaFileReducer,

  //Start of study module
  studyList: studyListReducer,
  studyCreate: studyCreateReducer,
  studyDelete: studyDeleteReducer,
  studyActivate: studyActivateReducer,
  studyDeactivate: studyDectivateReducer,
  studyEditBasic: studyEditBasicReducer,
  studyEditConsent: studyEditConsentReducer,
  stageAdd: stageAddReducer,
  stageDelete: stageDeleteReducer,
  stageEditBasic: stageEditBasicReducer,
  studyDetails: studyDetailsReducer,
  participantGroupAdd: participantGroupAddReducer,
  participantGroupDelete: participantGroupDeleteReducer,
  participantGroupEdit: participantGroupEditReducer,
  studyEditExceptConsent: studyEditExceptConsentReducer,
  studyLock: studyLockReducer,
  studyUnlock: studyUnlockReducer,
  settingsSetMutation: settingsSetMutationReducer,

  //Start of qx module
  qxList: qxListReducer, // Start of qx
  qxCreate: qxCreateReducer,
  qxDelete: qxDeleteReducer,
  qxDetails: qxDetailsReducer,
  qxEdit: qxEditReducer,
  mcList: mcListReducer,
  mcCreate: mcCreateReducer,
  mcDelete: mcDeleteReducer,
  mcDetails: mcDetailsReducer,
  mcEdit: mcEditReducer,
  qxLock: qxLockReducer,
  qxUnlock: qxUnlockReducer,
  qxVariableList: qxVariableListReducer,
  qxVariableCreate: qxVariableCreateReducer,
  qxVariableDetails: qxVariableDetailsReducer,
  qxVariableDelete: qxVariableDeleteReducer,
  qxVariableEdit: qxVariableEditReducer,

  //Start of participant module
  partiList: partiListReducer,
  assignParti: assignPartiReducer,
  downloadTextResp: downloadTextRespReducer,
  downloadRespTime: downloadRespTimeReducer,
  createParti: createPartiReducer,
  updateFitbitToken: updateFitbitTokenReducer,
  getFitbitSleepLog: getFitbitSleepLogReducer,
  createJitaiTasks: createJitaiTasksReducer,
  refreshJitaiTasks: refreshJitaiTasksReducer,
  saveJitaiDataResp: saveJitaiDataRespReducer,
  getJitaiDataResp: getJitaiDataRespReducer,
  connectAmiDevice: connectAmiDeviceReducer,

  //Start of ema module
  emaTaskList: emaTaskListReducer,

  //Start of access module
  allAccess: allAccessReducer,

  //Start of tx materials module
  txPageList: txPageListReducer,
  txPageCreate: txPageCreateReducer,
  txPageDelete: txPageDeleteReducer,
  txPageEdit: txPageEditReducer,
  txPageDetails: txPageDetailsReducer,
  customPageComponentList: customPageComponentListReducer,
  customPageComponentCreate: customPageComponentCreateReducer,
  customPageComponentDelete: customPageComponentDeleteReducer,
  customPageComponentEdit: customPageComponentEditReducer,
  customPageComponentDetails: customPageComponentDetailsReducer,

  //Start of tx progress module
  nextTxStageInfoList: nextTxStageInfoListReducer,
  nextTxStageInfoCreate: nextTxStageInfoCreateReducer,
  nextTxStageInfoDelete: nextTxStageInfoDeleteReducer,
  nextTxStageInfoEdit: nextTxStageInfoEditReducer,

  //Start of diary ax module
  diaryAxTaskList: diaryAxTaskListReducer,

  //Start of jitai module
  jitaiMessageList: jitaiMessageListReducer,
  jitaiMessageCreate: jitaiMessageCreateReducer,
  jitaiMessageUpdate: jitaiMessageUpdateReducer,
  jitaiMessageDelete: jitaiMessageDeleteReducer,
  jitaiVariableList: jitaiVariableListReducer,
  jitaiVariableCreate: jitaiVariableCreateReducer,
  jitaiVariableUpdate: jitaiVariableUpdateReducer,
  jitaiVariableDelete: jitaiVariableDeleteReducer,
  jitaiDecisionRuleList: jitaiDecisionRuleListReducer,
  jitaiDecisionRuleCreate: jitaiDecisionRuleCreateReducer,
  jitaiDecisionRuleUpdate: jitaiDecisionRuleUpdateReducer,
  jitaiDecisionRuleDelete: jitaiDecisionRuleDeleteReducer,
  jitaiRespList: jitaiRespListReducer,
  jitaiRespCreate: jitaiRespCreateReducer,
  jitaiRespUpdate: jitaiRespUpdateReducer,
  jitaiRespDelete: jitaiRespDeleteReducer,
  jitaiScheduledTaskList: jitaiScheduledTaskListReducer,
  jitaiRulesUsage: jitaiRulesUsageReducer,
  jitaiEvaluate: jitaiEvaluateReducer,
  jitaiParticipantActivity: jitaiParticipantActivityReducer,
})

// Set the initialState from the localStorage if existed
const userInfoFromStorage = localStorage.getItem('adminModuleUserInfo')
  ? JSON.parse(localStorage.getItem('adminModuleUserInfo'))
  : null

// get system owner info from local storage
const systemOwnerInfoFromStorage = localStorage.getItem(
  'adminModuleSystemOwnerInfo'
)
  ? JSON.parse(localStorage.getItem('adminModuleSystemOwnerInfo'))
  : null

// Each key is the key of combineReducers defined above
const initialState = {
  userLogin: { userInfo: userInfoFromStorage, attemptLogin: false },
  systemOwnerLogin: {
    systemOwnerInfo: systemOwnerInfoFromStorage,
    attemptLogin: false,
  },
}

const middleware = [thunk]

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
)

export default store
